// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { createCompanyUser } from "../../../account/actions/companyActions";
import {
  fetctAllPrincipals,
  fetchCompanyFacebases,
  adminUpdateUser
} from "../../../admin/actions/userAdminActions.js";
import { hasPrincipal } from "../../../global/containers/UserAuth";
import { LoadingProgress } from "imagus-components";
import CreateUserForm from "../../components/users/CreateUserForm";

type CreateUserFormReduxPropsType = {
  company: { [key: string]: * },
  facebases: Array<{ [key: string]: * }>,
  isAdmin?: boolean,
  isUserAdmin?: boolean,
  user?: { [key: string]: * },
  onClose: Function,
  openSnackbar: Function,
  currentUser: { [key: string]: * },
  groups: Array<{ [key: string]: * }>,
  companies: Array<{ [key: string]: * }>,
  userFacebases: Array<{ [key: string]: * }>,
  actions: {
    createCompanyUser: Function,
    fetctAllPrincipals: Function,
    fetchCompanyFacebases: Function,
    adminUpdateUser: Function
  }
};

class CreateUserFormRedux extends Component<CreateUserFormReduxPropsType, *> {
  componentDidMount() {
    if (this.props.groups === null) {
      this.props.actions.fetctAllPrincipals();
    }
    if (this.props.companies === null) {
      this.props.actions.fetchCompanyFacebases();
    }
  }

  createCompanyUser = (
    facebaseId: string,
    firstName: string,
    lastName: string,
    email: string,
    groups: Array<string>,
    doneCall: Function,
    failCall: Function,
    companyId?: string
  ): * => {
    this.props.actions.createCompanyUser(
      facebaseId,
      firstName,
      lastName,
      this.props.isUserAdmin ? companyId : this.props.company.id,
      email,
      groups,
      doneCall,
      failCall,
      this.props.isAdmin,
      this.props.isUserAdmin
    );
  };

  adminUpdateUser = (
    userUuid: string,
    facebaseId: string,
    firstName: string,
    lastName: string,
    companyId: string,
    email: string,
    groups: Array<string>,
    doneCallback: Function,
    failCallBack: Function
  ): * => {
    this.props.actions.adminUpdateUser(
      userUuid,
      facebaseId,
      firstName,
      lastName,
      companyId,
      email,
      groups,
      doneCallback,
      failCallBack
    );
  };

  render(): * {
    const isImagusAdmin = hasPrincipal(
      "imagus_admin",
      this.props.currentUser.groups
    );

    const facebaseList = this.props.isUserAdmin
      ? this.props.userFacebases &&
        this.props.userFacebases.map(
          (facebase: *, i: number): * => ({
            value: facebase.id,
            label: facebase.name + " (company: " + facebase.company.name + ")"
          })
        )
      : this.props.facebases &&
        this.props.facebases.map(
          (facebase: *): * => ({
            value: facebase.node.id,
            label: facebase.node.name
          })
        );

    const companyList =
      this.props.isUserAdmin && this.props.companies
        ? this.props.companies.map(
          (company: *): * => ({
            value: company.id,
            label: company.name
          })
        )
        : [];

    const groupList =
      isImagusAdmin && this.props.groups
        ? this.props.groups.map(
          (group: *): * => ({
            value: group.name,
            label: group.name
          })
        )
        : [];

    let user = null;
    if (this.props.isUserAdmin && this.props.user) {
      user = { ...this.props.user };

      const companies = this.props.companies ? [...this.props.companies] : [];
      const index = companies.findIndex(x => x.uuid === user.company.uuid);
      if (index > -1) {
        user.company_id = companies[index].id;
      }

      const facebases = this.props.userFacebases
        ? [...this.props.userFacebases]
        : [];
      const index2 = facebases.findIndex(x => x.uuid === user.facebase.uuid);
      if (index2 > -1) {
        user.facebase_id = facebases[index2].id;
      }
    }

    if ((this.props.user && user.company_id && user.facebase_id) || !this.props.user) {
      return (
        <CreateUserForm
          facebaseList={facebaseList}
          companyList={companyList}
          groupList={groupList}
          onClose={this.props.onClose}
          openSnackbar={this.props.openSnackbar}
          createCompanyUser={this.createCompanyUser}
          adminUpdateUser={this.adminUpdateUser}
          user={user}
          isImagusAdmin={isImagusAdmin}
          isUserAdmin={this.props.isUserAdmin}
        />
      );
    } else {
      return <LoadingProgress />;
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  currentUser: state.v3account.user,
  groups: state.v3admin.user.groups,
  companies: state.v3admin.user.companies,
  userFacebases: state.v3admin.user.facebases
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      createCompanyUser,
      fetctAllPrincipals,
      fetchCompanyFacebases,
      adminUpdateUser
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateUserFormRedux);
